export default "__VITE_ASSET__Czv4KqDV__"